import Vue from 'vue'
import moment from 'moment'

Vue.filter('profileName', (val) => {
  switch (val) {
    case 'administrator':
      return 'Administrador'
    case 'manager':
      return 'Gerente'
    case 'supervisor':
      return 'Supervisor'
    case 'attendant':
      return 'Atendente'
    default:
      return '---'
  }
})

Vue.filter('date', (val) => {
  if (val) {
    if (
      val &&
      typeof val === 'object' &&
      ['Timestamp', 't'].indexOf(val.constructor.name) > -1
    ) {
      if (val.toDate) {
        val = val.toDate()
      }
    }
    return moment(val).format('DD/MM/YYYY')
  }
})

Vue.filter('dateTime', (val) => {
  if (val) {
    if (
      val &&
      typeof val === 'object' &&
      ['Timestamp', 't'].indexOf(val.constructor.name) > -1
    ) {
      if (val.toDate) {
        val = val.toDate()
      }
    }
    return moment(val).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('shortDate', (val) => {
  if (val) {
    if (
      val &&
      typeof val === 'object' &&
      ['Timestamp', 't'].indexOf(val.constructor.name) > -1
    ) {
      if (val.toDate) {
        val = val.toDate()
      }
    }
    return moment(val).format('DD/MM')
  }
})
// ✅ REMOVIDO: Filtro 'money' duplicado - já existe em plugins/vueFilters.js
// Vue.filter('money', function (value) {
//   // ✅ LÓGICA CORRIGIDA: Converte o valor para número
//   let numberValue = parseFloat(value);

//   // Se não for um número válido (NaN), define como 0
//   if (isNaN(numberValue)) {
//     numberValue = 0;
//   }

//   const formatter = new Intl.NumberFormat('pt-BR', {
//     style: 'decimal',
//     minimumFractionDigits: 2,
//     maximumFractionDigits: 2,
//   });
//   return formatter.format(numberValue);
// });
